import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function AdminBar() {
  const navigate = useNavigate();
  const location = useLocation();
  // State to track if the bar is hidden
  const [isMinimized, setIsMinimized] = useState(false);

  const tabs = [
    { label: 'Business Written Approval', path: '/admin/business-written-approval' },
    { label: 'Testimonial Approval', path: '/admin/testimonial-approval' },
    { label: 'Business Claim Approval', path: '/admin/business-approval' },
    { label: 'Invited Reviews', path: '/admin/invited-reviews' },
    { label: 'Reports', path: '/admin/reports' },
    { label: 'Agents', path: '/admin/agents' },
  ];

  const handleNavigate = (path) => navigate(path);
  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <>
           <Helmet>
            <title>Admin | Sitemanifest</title> 
            
            <meta name="robots" content="noindex, nofollow" />
            
            <meta name="googlebot" content="noarchive" />
          </Helmet>
      {/* 1. Toggle Button (Always visible or appearing when minimized) */}
      <button
        onClick={() => setIsMinimized(!isMinimized)}
        className="fixed top-[115px] left-2 z-[110] bg-[#3A002D] text-white p-2 rounded-full shadow-lg hover:scale-110 transition-all border border-[#897EC4]"
        title={isMinimized ? "Show Menu" : "Minimize Menu"}
      >
        {isMinimized ? (
          // Right Arrow Icon (Show)
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
        ) : (
          // Left Arrow Icon (Hide)
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
        )}
      </button>

      {/* 2. The Main Nav Bar */}
      <div 
        className={`flex flex-row justify-between max-w-[1200px] rounded-[6px] left-1/2 mx-auto w-full h-[70px] bg-[#897EC4] fixed top-[100px] z-100 transition-all duration-500 ease-in-out shadow-xl ${
          isMinimized 
            ? 'transform translate-x-[-120%] opacity-0 pointer-events-none' // Slide far left and fade
            : 'transform translate-x-[-50%] opacity-100' // Back to center
        }`}
      >
        {tabs.map((tab) => (
          <div
            key={tab.path}
            onClick={() => handleNavigate(tab.path)}
            className={`flex items-center justify-center px-[15px] border-r last:border-r-0 rounded-[6px] cursor-pointer w-full h-full z-10 transition-colors ${
              isActive(tab.path) ? 'bg-[#3A002D]' : 'hover:bg-[#7a6fb3]'
            }`}
          >
            <span className="text-white text-[14px] font-bold text-center leading-tight">
              {tab.label}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}